"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHelocOriginationChannelGated = exports.isHomeOriginationChannelGated = exports.CHANNEL_GATED_HOME_ORIGINATION_STATES = exports.isCoApplicantTitleOrMarriageRequiredForState = exports.STATES_REQUIRING_CO_APPLICANT_TITLE_OR_MARRIAGE = exports.isCoApplicantBlockedForState = exports.BLOCKED_CO_APPLICANT_STATES = exports.OFFER_CONTINGENCY_STATES = exports.statesToRoundImgMap = exports.STATE_TWO_LETTER_CODE_TO_FULL_NAME_PAIRS = exports.StateFullNames = exports.isStateTwoLetterCode = exports.STATE_TWO_LETTER_CODES = exports.StateTwoLetterCodes = void 0;
exports.stateStringToTwoLetterCode = stateStringToTwoLetterCode;
const asset_1 = require("./asset");
/** @TranslateToPython */
var StateTwoLetterCodes;
(function (StateTwoLetterCodes) {
    StateTwoLetterCodes["alabama"] = "AL";
    StateTwoLetterCodes["alaska"] = "AK";
    StateTwoLetterCodes["americanSamoa"] = "AS";
    StateTwoLetterCodes["arizona"] = "AZ";
    StateTwoLetterCodes["arkansas"] = "AR";
    StateTwoLetterCodes["california"] = "CA";
    StateTwoLetterCodes["colorado"] = "CO";
    StateTwoLetterCodes["connecticut"] = "CT";
    StateTwoLetterCodes["delaware"] = "DE";
    StateTwoLetterCodes["districtOfColumbia"] = "DC";
    StateTwoLetterCodes["florida"] = "FL";
    StateTwoLetterCodes["georgia"] = "GA";
    StateTwoLetterCodes["guam"] = "GU";
    StateTwoLetterCodes["hawaii"] = "HI";
    StateTwoLetterCodes["idaho"] = "ID";
    StateTwoLetterCodes["illinois"] = "IL";
    StateTwoLetterCodes["indiana"] = "IN";
    StateTwoLetterCodes["iowa"] = "IA";
    StateTwoLetterCodes["kansas"] = "KS";
    StateTwoLetterCodes["kentucky"] = "KY";
    StateTwoLetterCodes["louisiana"] = "LA";
    StateTwoLetterCodes["maine"] = "ME";
    StateTwoLetterCodes["marshallIslands"] = "MH";
    StateTwoLetterCodes["maryland"] = "MD";
    StateTwoLetterCodes["massachusetts"] = "MA";
    StateTwoLetterCodes["michigan"] = "MI";
    StateTwoLetterCodes["minnesota"] = "MN";
    StateTwoLetterCodes["mississippi"] = "MS";
    StateTwoLetterCodes["missouri"] = "MO";
    StateTwoLetterCodes["montana"] = "MT";
    StateTwoLetterCodes["nebraska"] = "NE";
    StateTwoLetterCodes["nevada"] = "NV";
    StateTwoLetterCodes["newHampshire"] = "NH";
    StateTwoLetterCodes["newJersey"] = "NJ";
    StateTwoLetterCodes["newMexico"] = "NM";
    StateTwoLetterCodes["newYork"] = "NY";
    StateTwoLetterCodes["northCarolina"] = "NC";
    StateTwoLetterCodes["northDakota"] = "ND";
    StateTwoLetterCodes["ohio"] = "OH";
    StateTwoLetterCodes["oklahoma"] = "OK";
    StateTwoLetterCodes["oregon"] = "OR";
    StateTwoLetterCodes["palau"] = "PW";
    StateTwoLetterCodes["pennsylvania"] = "PA";
    StateTwoLetterCodes["puertoRico"] = "PR";
    StateTwoLetterCodes["rhodeIsland"] = "RI";
    StateTwoLetterCodes["southCarolina"] = "SC";
    StateTwoLetterCodes["southDakota"] = "SD";
    StateTwoLetterCodes["tennessee"] = "TN";
    StateTwoLetterCodes["texas"] = "TX";
    StateTwoLetterCodes["utah"] = "UT";
    StateTwoLetterCodes["vermont"] = "VT";
    StateTwoLetterCodes["virginia"] = "VA";
    StateTwoLetterCodes["washington"] = "WA";
    StateTwoLetterCodes["westVirginia"] = "WV";
    StateTwoLetterCodes["wisconsin"] = "WI";
    StateTwoLetterCodes["wyoming"] = "WY";
})(StateTwoLetterCodes || (exports.StateTwoLetterCodes = StateTwoLetterCodes = {}));
exports.STATE_TWO_LETTER_CODES = Object.values(StateTwoLetterCodes);
const STATE_TWO_LETTER_CODE_SET = new Set(exports.STATE_TWO_LETTER_CODES);
const isStateTwoLetterCode = (state) => {
    return STATE_TWO_LETTER_CODE_SET.has(state);
};
exports.isStateTwoLetterCode = isStateTwoLetterCode;
/** @TranslateToPython */
var StateFullNames;
(function (StateFullNames) {
    StateFullNames["alabama"] = "ALABAMA";
    StateFullNames["alaska"] = "ALASKA";
    StateFullNames["americanSamoa"] = "AMERICAN SAMOA";
    StateFullNames["arizona"] = "ARIZONA";
    StateFullNames["arkansas"] = "ARKANSAS";
    StateFullNames["california"] = "CALIFORNIA";
    StateFullNames["colorado"] = "COLORADO";
    StateFullNames["connecticut"] = "CONNECTICUT";
    StateFullNames["delaware"] = "DELAWARE";
    StateFullNames["districtOfColumbia"] = "DISTRICT OF COLUMBIA";
    StateFullNames["florida"] = "FLORIDA";
    StateFullNames["georgia"] = "GEORGIA";
    StateFullNames["guam"] = "GUAM";
    StateFullNames["hawaii"] = "HAWAII";
    StateFullNames["idaho"] = "IDAHO";
    StateFullNames["illinois"] = "ILLINOIS";
    StateFullNames["indiana"] = "INDIANA";
    StateFullNames["iowa"] = "IOWA";
    StateFullNames["kansas"] = "KANSAS";
    StateFullNames["kentucky"] = "KENTUCKY";
    StateFullNames["louisiana"] = "LOUISIANA";
    StateFullNames["maine"] = "MAINE";
    StateFullNames["marshallIslands"] = "MARSHALL ISLANDS";
    StateFullNames["maryland"] = "MARYLAND";
    StateFullNames["massachusetts"] = "MASSACHUSETTS";
    StateFullNames["michigan"] = "MICHIGAN";
    StateFullNames["minnesota"] = "MINNESOTA";
    StateFullNames["mississippi"] = "MISSISSIPPI";
    StateFullNames["missouri"] = "MISSOURI";
    StateFullNames["montana"] = "MONTANA";
    StateFullNames["nebraska"] = "NEBRASKA";
    StateFullNames["nevada"] = "NEVADA";
    StateFullNames["newHampshire"] = "NEW HAMPSHIRE";
    StateFullNames["newJersey"] = "NEW JERSEY";
    StateFullNames["newMexico"] = "NEW MEXICO";
    StateFullNames["newYork"] = "NEW YORK";
    StateFullNames["northCarolina"] = "NORTH CAROLINA";
    StateFullNames["northDakota"] = "NORTH DAKOTA";
    StateFullNames["ohio"] = "OHIO";
    StateFullNames["oklahoma"] = "OKLAHOMA";
    StateFullNames["oregon"] = "OREGON";
    StateFullNames["palau"] = "PALAU";
    StateFullNames["pennsylvania"] = "PENNSYLVANIA";
    StateFullNames["puertoRico"] = "PUERTO RICO";
    StateFullNames["rhodeIsland"] = "RHODE ISLAND";
    StateFullNames["southCarolina"] = "SOUTH CAROLINA";
    StateFullNames["southDakota"] = "SOUTH DAKOTA";
    StateFullNames["tennessee"] = "TENNESSEE";
    StateFullNames["texas"] = "TEXAS";
    StateFullNames["utah"] = "UTAH";
    StateFullNames["vermont"] = "VERMONT";
    StateFullNames["virginia"] = "VIRGINIA";
    StateFullNames["washington"] = "WASHINGTON";
    StateFullNames["westVirginia"] = "WEST VIRGINIA";
    StateFullNames["wisconsin"] = "WISCONSIN";
    StateFullNames["wyoming"] = "WYOMING";
})(StateFullNames || (exports.StateFullNames = StateFullNames = {}));
// NOTE: if you add more territories here, please also add to BLACKLISTED_UCC_CARD_STATES
exports.STATE_TWO_LETTER_CODE_TO_FULL_NAME_PAIRS = [
    [StateTwoLetterCodes.alabama, StateFullNames.alabama],
    [StateTwoLetterCodes.alaska, StateFullNames.alaska],
    [StateTwoLetterCodes.americanSamoa, StateFullNames.americanSamoa],
    [StateTwoLetterCodes.arizona, StateFullNames.arizona],
    [StateTwoLetterCodes.arkansas, StateFullNames.arkansas],
    [StateTwoLetterCodes.california, StateFullNames.california],
    [StateTwoLetterCodes.colorado, StateFullNames.colorado],
    [StateTwoLetterCodes.connecticut, StateFullNames.connecticut],
    [StateTwoLetterCodes.delaware, StateFullNames.delaware],
    [StateTwoLetterCodes.districtOfColumbia, StateFullNames.districtOfColumbia],
    [StateTwoLetterCodes.florida, StateFullNames.florida],
    [StateTwoLetterCodes.georgia, StateFullNames.georgia],
    [StateTwoLetterCodes.guam, StateFullNames.guam],
    [StateTwoLetterCodes.hawaii, StateFullNames.hawaii],
    [StateTwoLetterCodes.idaho, StateFullNames.idaho],
    [StateTwoLetterCodes.illinois, StateFullNames.illinois],
    [StateTwoLetterCodes.indiana, StateFullNames.indiana],
    [StateTwoLetterCodes.iowa, StateFullNames.iowa],
    [StateTwoLetterCodes.kansas, StateFullNames.kansas],
    [StateTwoLetterCodes.kentucky, StateFullNames.kentucky],
    [StateTwoLetterCodes.louisiana, StateFullNames.louisiana],
    [StateTwoLetterCodes.maine, StateFullNames.maine],
    [StateTwoLetterCodes.marshallIslands, StateFullNames.marshallIslands],
    [StateTwoLetterCodes.maryland, StateFullNames.maryland],
    [StateTwoLetterCodes.massachusetts, StateFullNames.massachusetts],
    [StateTwoLetterCodes.michigan, StateFullNames.michigan],
    [StateTwoLetterCodes.minnesota, StateFullNames.minnesota],
    [StateTwoLetterCodes.mississippi, StateFullNames.mississippi],
    [StateTwoLetterCodes.missouri, StateFullNames.missouri],
    [StateTwoLetterCodes.montana, StateFullNames.montana],
    [StateTwoLetterCodes.nebraska, StateFullNames.nebraska],
    [StateTwoLetterCodes.nevada, StateFullNames.nevada],
    [StateTwoLetterCodes.newHampshire, StateFullNames.newHampshire],
    [StateTwoLetterCodes.newJersey, StateFullNames.newJersey],
    [StateTwoLetterCodes.newMexico, StateFullNames.newMexico],
    [StateTwoLetterCodes.newYork, StateFullNames.newYork],
    [StateTwoLetterCodes.northCarolina, StateFullNames.northCarolina],
    [StateTwoLetterCodes.northDakota, StateFullNames.northDakota],
    [StateTwoLetterCodes.ohio, StateFullNames.ohio],
    [StateTwoLetterCodes.oklahoma, StateFullNames.oklahoma],
    [StateTwoLetterCodes.oregon, StateFullNames.oregon],
    [StateTwoLetterCodes.palau, StateFullNames.palau],
    [StateTwoLetterCodes.pennsylvania, StateFullNames.pennsylvania],
    [StateTwoLetterCodes.puertoRico, StateFullNames.puertoRico],
    [StateTwoLetterCodes.rhodeIsland, StateFullNames.rhodeIsland],
    [StateTwoLetterCodes.southCarolina, StateFullNames.southCarolina],
    [StateTwoLetterCodes.southDakota, StateFullNames.southDakota],
    [StateTwoLetterCodes.tennessee, StateFullNames.tennessee],
    [StateTwoLetterCodes.texas, StateFullNames.texas],
    [StateTwoLetterCodes.utah, StateFullNames.utah],
    [StateTwoLetterCodes.vermont, StateFullNames.vermont],
    [StateTwoLetterCodes.virginia, StateFullNames.virginia],
    [StateTwoLetterCodes.washington, StateFullNames.washington],
    [StateTwoLetterCodes.westVirginia, StateFullNames.westVirginia],
    [StateTwoLetterCodes.wisconsin, StateFullNames.wisconsin],
    [StateTwoLetterCodes.wyoming, StateFullNames.wyoming],
];
// Does not contain all states - only the rounded states found on the frontend
// See aven_frontend/aven/src/assets/images/origination/roundedStates
exports.statesToRoundImgMap = new Map([
    ['AR', 'https://aven.com/email/images/roundedStates/arkansas.png'],
    ['DE', 'https://aven.com/email/images/roundedStates/delaware.png'],
    ['CT', 'https://aven.com/email/images/roundedStates/connecticut.png'],
    ['DC', 'https://aven.com/email/images/roundedStates/district_of_columbia.png'],
    ['GA', 'https://aven.com/email/images/roundedStates/georgia.png'],
    ['HI', 'https://aven.com/email/images/roundedStates/hawaii.png'],
    ['ID', 'https://aven.com/email/images/roundedStates/idaho.png'],
    ['IN', 'https://aven.com/email/images/roundedStates/indiana.png'],
    ['LA', 'https://aven.com/email/images/roundedStates/louisiana.png'],
    ['ME', 'https://aven.com/email/images/roundedStates/maine.png'],
    ['MD', 'https://aven.com/email/images/roundedStates/maryland.png'],
    ['MA', 'https://aven.com/email/images/roundedStates/massachusetts.png'],
    ['MI', 'https://aven.com/email/images/roundedStates/michigan.png'],
    ['MN', 'https://aven.com/email/images/roundedStates/minnesota.png'],
    ['MS', 'https://aven.com/email/images/roundedStates/mississippi.png'],
    ['MO', 'https://aven.com/email/images/roundedStates/missouri.png'],
    ['MT', 'https://aven.com/email/images/roundedStates/montana.png'],
    ['NE', 'https://aven.com/email/images/roundedStates/nebraska.png'],
    ['NV', 'https://aven.com/email/images/roundedStates/nevada.png'],
    ['NJ', 'https://aven.com/email/images/roundedStates/new_jersey.png'],
    ['NM', 'https://aven.com/email/images/roundedStates/new_mexico.png'],
    ['NY', 'https://aven.com/email/images/roundedStates/new_york.png'],
    ['NC', 'https://aven.com/email/images/roundedStates/north_carolina.png'],
    ['ND', 'https://aven.com/email/images/roundedStates/north_dakota.png'],
    ['OK', 'https://aven.com/email/images/roundedStates/oklahoma.png'],
    ['OR', 'https://aven.com/email/images/roundedStates/oregon.png'],
    ['RI', 'https://aven.com/email/images/roundedStates/rhode_island.png'],
    ['SC', 'https://aven.com/email/images/roundedStates/south_carolina.png'],
    ['SD', 'https://aven.com/email/images/roundedStates/south_dakota.png'],
    ['TX', 'https://aven.com/email/images/roundedStates/texas.png'],
    ['UT', 'https://aven.com/email/images/roundedStates/utah.png'],
    ['VT', 'https://aven.com/email/images/roundedStates/vermont.png'],
    ['VA', 'https://aven.com/email/images/roundedStates/virginia.png'],
    ['WA', 'https://aven.com/email/images/roundedStates/washington.png'],
    ['WV', 'https://aven.com/email/images/roundedStates/west_virginia.png'],
    ['WI', 'https://aven.com/email/images/roundedStates/wisconsin.png'],
]);
exports.OFFER_CONTINGENCY_STATES = [StateTwoLetterCodes.texas];
// Two TX-only state sets live below and are NOT interchangeable:
//   • BLOCKED_CO_APPLICANT_STATES — a temporary product gate on intake.
//   • STATES_REQUIRING_CO_APPLICANT_TITLE_OR_MARRIAGE — the §50(a)(6) rule itself, which holds
//     wherever co-applicants are admitted at all.
// States where our co-applicant flow doesn't yet support home equity. Texas home-equity
// liens have spousal-consent / joint-homestead-signature requirements under Tex. Const.
// art. XVI §50(a)(6) that the current co-applicant model doesn't capture, so TX LAs are
// routed single-applicant-only until that's built. State axis of the gate that decides
// whether to offer `deniedIndividualCanAddCoApplicant` on a DTI-only-solo denial; pair
// with `doesAssetTypeSupportAddCoApplicantOnDtiFailure` for the asset-type axis. Set
// element type is `string` (not `StateTwoLetterCodes`) so callers can pass `home.state`
// without a cast — Home.state is `string` because the column was not declared with the
// enum type when Home was first introduced.
exports.BLOCKED_CO_APPLICANT_STATES = new Set([StateTwoLetterCodes.texas]);
/**
 * True if the state is in BLOCKED_CO_APPLICANT_STATES. Returns false on null/undefined
 * (matches sibling state-set helpers: OFFER_CONTINGENCY_STATES.includes,
 * BLACKLISTED_UCC_CARD_STATES.has). See BLOCKED_CO_APPLICANT_STATES for the contract this
 * predicate enforces and the asset-type partner predicate.
 */
const isCoApplicantBlockedForState = (state) => {
    return state !== null && state !== undefined && exports.BLOCKED_CO_APPLICANT_STATES.has(state);
};
exports.isCoApplicantBlockedForState = isCoApplicantBlockedForState;
// States requiring every co-applicant to be a homestead owner (on title) or married to the primary.
// Texas only today, under Tex. Const. art. XVI §50(a)(6): the lien needs each owner's and each spouse's
// consent, so a co-applicant must be an owner or the owner's spouse — get it wrong and all principal and
// interest is forfeit (§50(a)(6)(Q)(xi)).
/** @TranslateToPython */
exports.STATES_REQUIRING_CO_APPLICANT_TITLE_OR_MARRIAGE = [StateTwoLetterCodes.texas];
// Element type `string` so callers pass `home.state` uncast.
const STATES_REQUIRING_CO_APPLICANT_TITLE_OR_MARRIAGE_SET = new Set(exports.STATES_REQUIRING_CO_APPLICANT_TITLE_OR_MARRIAGE);
/** True if the state requires every co-applicant to be on title or married to the primary; false on null/undefined. */
const isCoApplicantTitleOrMarriageRequiredForState = (state) => {
    return state !== null && state !== undefined && STATES_REQUIRING_CO_APPLICANT_TITLE_OR_MARRIAGE_SET.has(state);
};
exports.isCoApplicantTitleOrMarriageRequiredForState = isCoApplicantTitleOrMarriageRequiredForState;
// States where home-asset origination is LAUNCHED but channel-gated: the product is live (the
// state stays in SUPPORTED_STATES so the soft-launch channel can underwrite), but most entry
// points are held back during the soft launch. "Channel-gated" and "supported" are orthogonal:
// a state can be both supported (launched) and channel-gated (most channels held back) — exactly
// TX's posture today.
//
// Canonical single source of truth across every home-LA entry point (consumer FE, partner FE,
// UCC-and-3PL upgrade chokepoints). Channel-specific carve-outs (asset-type filters) stay at their
// callsites — per-entry-point policy, not per-state policy. Set element type is `string` (not
// `StateTwoLetterCodes`) so callers can pass `home.state` / `thirdPartyLead.propertyState` /
// payload fields without a cast.
//
// TEMPORARY: exists only for the TX soft launch; remove once TX is fully launched on all
// channels. Teardown = delete this Set + isHomeOriginationChannelGated + every callsite. Grep both
// names to find every surface. There is no landing-page or referrer carve-out to unwind: the gate
// keys on whether the application's compositor template is Texas-capable.
exports.CHANNEL_GATED_HOME_ORIGINATION_STATES = new Set([StateTwoLetterCodes.texas]);
/**
 * State-only channel gate: is this entry point held back for this state during the soft launch?
 * The gate's purpose is the HELOC soft launch — blocking first-lien mortgage is never the goal, so
 * {@link isHelocOriginationChannelGated} (asset-scoped) is the correct intent whenever an asset type
 * is available. Use THIS bare form only when no asset type is in hand at the callsite, and only
 * where the surface can't carry a mortgage anyway (otherwise it would over-block mortgage, which has
 * a compliant path in the gated state). Returns false on null/undefined (matches sibling state-set
 * helpers). Trusts upstream writers to persist canonical 2-letter uppercase values.
 */
const isHomeOriginationChannelGated = (state) => {
    return state !== null && state !== undefined && exports.CHANNEL_GATED_HOME_ORIGINATION_STATES.has(state);
};
exports.isHomeOriginationChannelGated = isHomeOriginationChannelGated;
/**
 * Asset-scoped gate: HELOC held back for this state during the soft launch, but first-lien
 * homeMortgage stays allowed — it has a compliant path in the gated state and must not be swept
 * into the HELOC soft-launch gate despite sharing the "home" state space. That mortgage exclusion
 * is the whole reason this exists alongside {@link isHomeOriginationChannelGated}: this gates only
 * HELOC ({@link isHelocAssetType}, excludes homeMortgage / UCC / non-HELOC), the other gates by
 * state for all products. Use this whenever you hold an asset type that could be a mortgage; folds
 * the `isHelocAssetType(...) && isHomeOriginationChannelGated(...)` pairing into one call. Returns
 * false on null/undefined asset or state. TEMPORARY — remove with CHANNEL_GATED_HOME_ORIGINATION_STATES at launch.
 */
const isHelocOriginationChannelGated = (assetType, state) => {
    if (assetType === null || assetType === undefined || !(0, asset_1.isHelocAssetType)(assetType)) {
        return false;
    }
    return (0, exports.isHomeOriginationChannelGated)(state);
};
exports.isHelocOriginationChannelGated = isHelocOriginationChannelGated;
// Normalization helpers for state strings
const buildStateNormalizationMaps = () => {
    const twoLetterToTwoLetter = new Map();
    const fullNameToTwoLetter = new Map();
    for (const [two, full] of exports.STATE_TWO_LETTER_CODE_TO_FULL_NAME_PAIRS) {
        twoLetterToTwoLetter.set(String(two).toUpperCase(), two);
        fullNameToTwoLetter.set(String(full).toUpperCase(), two);
    }
    return { twoLetterToTwoLetter, fullNameToTwoLetter };
};
const { twoLetterToTwoLetter: __twoLetterToTwoLetter, fullNameToTwoLetter: __fullNameToTwoLetter } = buildStateNormalizationMaps();
/**
 * Normalize a state string (two-letter or full name) to a StateTwoLetterCodes value.
 * Returns undefined if input is falsy or unrecognized.
 */
function stateStringToTwoLetterCode(state) {
    if (!state) {
        return undefined;
    }
    const key = String(state).toUpperCase();
    return __twoLetterToTwoLetter.get(key) ?? __fullNameToTwoLetter.get(key) ?? undefined;
}
